import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query CompanyPage($id: ID!,  $masterLimit: Int) {
      CompanyPage: Company(id: $id) {
        ...companyDetail
        ...companyBigDetail
        ...companyArtworks
        ...companyFilms
        ...companyProducts
        ...companyPeople
        ...companyBrands
      }
    }
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.companyFilms}
    ${fragments.companyPeople}
    ${fragments.brandDetail}
    ${fragments.companyBigDetail}
    ${fragments.brandArtworks}
    ${fragments.companyProducts}
    ${fragments.companyBrands}
    ${fragments.productDetail}
    ${fragments.productArtworks}
    ${fragments.productCategory}
    ${fragments.productCategoryTree}
    ${fragments.companyArtworks}
    ${fragments.companyNames}
    ${fragments.companyNameDetail}
    ${fragments.companyDetail}
    ${fragments.relationshipTypeDetail}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.profession}
    ${fragments.companyType}
    ${fragments.companyTypeTree}
    ${fragments.filmBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardAncestor}
    ${fragments.personBigAwards}
    ${fragments.companyDepartmentDetail}
  `
